module.exports = __webpack_public_path__ + "static/9.2-f35a2bea2b4b92e521832d450881e4dd.jpg";